import axiosInstance from "./AxiosInstance";

export const getNotifications = async (page = 1, perPage = 15) => {
  try {
    const response = await axiosInstance.get(`api/notifications?page=${page}&per_page=${perPage}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};

export const seenNotifications = async () => {
  try {
    const response = await axiosInstance.post(`api/notifications/read`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};



export const getNotificationsCount = async () => {
  try {
    const response = await axiosInstance.get(`api/notifications/unread/count`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};
